import type { UpdateProjectErrors } from "@/client";

export type ValidationError422 = UpdateProjectErrors[422];
export function isValidationError422(res: {
	error?: unknown;
	response?: { status: number };
}): res is { error: ValidationError422; response: { status: 422 } } {
	return (
		res.response.status === 422 &&
		res.error !== undefined &&
		typeof res.error === "object" &&
		res.error !== null
	);
}
